export enum CommunicationPerimssions {
  Communication = 'communication',
  Template = 'template',
  RecipientGroup = 'recipient-group',
  StandardTemplate = 'standard-template',
  ContentNotificationSuper = 'content-notification_super',
  ContentNotificationAdmin = 'content-notification_admin',
  Text = 'text',
}
